import { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Link,
  Checkbox,
  VStack,
  Heading,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useHistory } from "react-router-dom";

function LoginInput() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const history = useHistory();

  const validate = () => {
    let newErrors = {};

    if (!email) {
      newErrors.email = "Το email είναι απαραίτητο.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      newErrors.email = "Μη έγκυρη διεύθυνση email.";
    }

    if (!password) {
      newErrors.password = "Ο κωδικός είναι απαραίτητος.";
    } else if (password.length < 6) {
      newErrors.password = "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      const payload = { email, password };
      console.log("Payload:", payload);
      history.push("/admin/lista_paraggelion");
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="#e6ebf1" p={4}>
      <Box bg="white" p={8} rounded="lg" boxShadow="lg" w={{ base: "100%", sm: "400px" }}>
        <Heading size="lg" textAlign="center" mb={6} color="#3ba3a7">
          Καλώς ήρθατε
        </Heading>
        <VStack spacing={4}>
          <FormControl isInvalid={errors.email}>
            <FormLabel>Εmail</FormLabel>
            <Input
              type="email"
              placeholder="διεύθυνση email"
              focusBorderColor="#3ba3a7"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <Text color="red.500">{errors.email}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.password}>
            <FormLabel>Κωδικός</FormLabel>
            <InputGroup>
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Γράψε τον κωδικό σου"
                focusBorderColor="#3ba3a7"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement>
                <Button variant="ghost" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <ViewOffIcon /> : <ViewIcon />}
                </Button>
              </InputRightElement>
            </InputGroup>
            {errors.password && <Text color="red.500">{errors.password}</Text>}
          </FormControl>

          <Box display="flex" justifyContent="space-between" w="100%">
            <Checkbox>Να με θυμάσαι</Checkbox>
            <Link color="#7c8ba1" fontWeight="bold">Ξέχασες τον κωδικό;</Link>
          </Box>

          <Button
            bg="#3ba3a7"
            color="white"
            w="full"
            _hover={{ bg: "#2a7d7f" }}
            onClick={handleSubmit}
          >
            Σύνδεση
          </Button>
        </VStack>
      </Box>
    </Box>
  );
}

export default LoginInput;
